import React, { useCallback, useState, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import timezones from 'countries-and-timezones';
import classnames from 'classnames';

// styles
import styles from '../../../../../../styles/modals.module.scss';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentPartner } from '../../../../../../redux/selectors/authentication';
import {
  doCreateNetwork,
  doCreateOrganisationSite,
  doDeleteNetwork,
  doReadOrganisationSites,
  doUpdateOrganisationSite,
} from '../../../../../../redux/thunks/organisation';
// components
import Modal from '../../../../../../components/Modals/Modal';
import ButtonCustom from '../../../../../../components/Buttons/Button';
import TextInput from '../../../../../../components/Inputs/TextInput';
import { textVerification } from '../../../../../../utils/formValdations';
import { selectIsLoading } from '../../../../../../redux/selectors/miscellaneous';
import { selectOrganisation } from '../../../../../../redux/selectors/organisation';
import Dropdown from '../../../../../../components/Inputs/Dropdown';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SquareDelete from '../../../../../../components/SquareDelete/SquareDelete';
import ModalAlert from '../../../../../../components/Modals/ModalAlert';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import SDialog from '../../../../../../components/SDialog/SDialog';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import Typography from '../../../../../../components/Typography/Typography';
import SButton from '../../../../../../components/SButton/SButton';

const maxNetworks = 2;
// const NETWORK_NAME_SEPARATOR = ' - ';

const AddOrEditSiteModal = ({
  showSitePopup,
  onClose,
  togglePopup,
  site,
  setSite,
  mode = 'add',
}) => {
  const [siteName, setSiteName] = useState({ value: site?.name ? site?.name : '', error: '' });
  const [location, setLocation] = useState({
    value: site?.location ? site?.location : '',
    error: '',
  });
  const [timezone, setTimezone] = useState(site?.timezone ? site?.timezone : '');
  const [countryTimezones, setCountryTimezones] = useState([]);
  const [showDeleteNetworkPopup, setShowDeleteNetworkPopup] = useState(false);
  const [currentNetworkId, setcurrentNetworkId] = useState({ id: '', name: '' });
  const [networks, setNetworks] = useState(
    site?.networks
      ? site?.networks.map((network) => {
        return { id: network.id, value: network.name, error: '' };
      })
      : [{ id: '', value: '', error: '' }],
  );

  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentPartner);
  const org = useSelector(selectOrganisation);
  const { customerId } = useParams();
  const isLoading = useSelector(selectIsLoading);

  useEffect(() => {
    if (site?.name && site?.location) {
      setSiteName({ value: site?.name, error: '' });
      setLocation({ value: site?.location, error: '' });
    }
  }, [site?.name, site?.location]);

  useEffect(() => {
    if (org?.generalSetting?.country) {
      const allTimezones = timezones.getCountry(org?.generalSetting?.country);
      if (allTimezones?.timezones) {
        setCountryTimezones(
          allTimezones?.timezones?.map((elem, i) => {
            return { id: i + 1, name: elem };
          }),
        );
      }
    }
  }, [org]);

  const popupToggle = useCallback(() => {
    togglePopup('AddOrEditSite');
  }, [togglePopup]);

  const resetAndClose = useCallback(() => {
    setSite(null);
    popupToggle();
  }, [popupToggle, setSite]);

  const handleNetworkAddRemove = (type, index) => {
    if (type === 'add') {
      setNetworks((oldState) => {
        return [...oldState, { id: '', value: `${siteName?.value} - `, error: '' }];
      });
    } else {
      // const item = networks.splice(index, 1);
      if (networks[index].id !== '') {
        setShowDeleteNetworkPopup(true);
        setcurrentNetworkId({ id: networks[index].id, name: networks[index].value });
      }

      if (mode === 'add' || networks[index].id === '') {
        setNetworks((oldState) => {
          const newState = [...oldState];
          newState.splice(index, 1);
          return newState;
        });
      }
    }
  };

  const handleDeleteNetwork = () => {
    dispatch(doDeleteNetwork(
      currentNetworkId?.id,
      () => {
        dispatch(
          doReadOrganisationSites({
            partnerId: currentUser.partnerId,
            organisationId: customerId,
            displayNotification: false,
          }),
        );
        setShowDeleteNetworkPopup(false);
        setNetworks(prev => prev?.filter(n => n?.id !== currentNetworkId?.id))
      }
    ));
  };
  const handleMultifieldChange = (e, index) => {
    const { value } = e?.currentTarget;
    const errorText = 'Please enter a valid';

    let error = '';
    if (value && networks.filter((network) => network.value === value).length > 0) {
      error = `Network Name Should Be Unique`;
    } else if (textVerification(value, 2)) error = `${errorText} Network Name`;
    const nName = value.includes(siteName.value)
      ? value
      : siteName.value + ' - ' + value.slice(siteName.value.length);

    if (!value?.startsWith(`${siteName?.value} - `)) {
      return;
    }

    if (nName.includes(siteName.value + ' - ')) {
      setNetworks((oldState) => {
        const newState = [...oldState];
        newState[index] = { id: newState[index].id, value: nName, error };
        return newState;
      });
    } else {
      // Prevent further backspacing if siteName and '-' are not present
      setNetworks((oldState) => {
        const newState = [...oldState];
        newState[index] = {
          id: newState[index].id,
          value: siteName.value + ' - ' + nName.slice(siteName.value.length + 3),
          error,
        };
        return newState;
      });
    }
    // setNetworks((oldState) => {
    //   const newState = [...oldState];
    //   newState[index] = { id: newState[index].id, value: nName, error };
    //   return newState;
    // });
  };

  const handleChange = (e) => {
    const { name, value } = e?.currentTarget;
    const errorText = 'Please enter a valid';
    let error = '';
    switch (name) {
      case 'name':
        if (textVerification(value, 2)) error = `${errorText} site name`;
        setSiteName({ value, error });
        setNetworks(prev => prev?.map(n => {
          if (n?.id === '') {
            return {
              ...n,
              value: n?.value ? n?.value?.replace(`${siteName?.value} - `, `${value} - `) : `${value} - `
            }
          }
          return n;
        }))
        break;
      case 'location':
        if (textVerification(value, 2)) error = `${errorText} location`;
        setLocation({ value, error });
        break;
      default:
        break;
    }
  };

  const handleCreateSite = useCallback(() => {
    const payload = {
      name: siteName?.value,
      location: location?.value,
      timezone: timezone,
      networks: networks
        ? networks.map((network) => {
          return { name: network.value };
        })
        : [],
    };
    dispatch(
      doCreateOrganisationSite({
        partnerId: currentUser.partnerId,
        organisationId: customerId,
        payload,
        callback: resetAndClose,
      }),
    );
  }, [
    currentUser.partnerId,
    customerId,
    dispatch,
    location?.value,
    resetAndClose,
    siteName?.value,
    timezone,
    networks,
  ]);

  const handleUpdateSite = useCallback(() => {
    const payload = {
      name: siteName?.value,
      location: location?.value,
      networks: networks
        ? networks.map((network) => {
          return { id: network.id, name: network.value };
        })
        : [],
    };

    if (siteName?.value !== site?.name || location?.value !== site?.location) {
      dispatch(
        doUpdateOrganisationSite({
          partnerId: currentUser.partnerId,
          organisationId: customerId,
          siteId: site?.id,
          payload,
          callback: togglePopup('AddOrEditSite'),
        }),
      );
    }

    networks.map((item) => {
      if (!item.id) {
        dispatch(doCreateNetwork(
          site.id,
          { name: item.value },
          () => {
            dispatch(
              doReadOrganisationSites({
                partnerId: currentUser.partnerId,
                organisationId: customerId,
                displayNotification: false,
              }),
            );
            togglePopup('AddOrEditSite')
          }
        ));
      }
      return 'success';
    });
  }, [
    currentUser.partnerId,
    customerId,
    dispatch,
    location?.value,
    siteName?.value,
    site?.id,
    togglePopup,
    networks,
  ]);

  const editDisabled = useMemo(() => {
    const newNetwork = networks?.filter(n => !n?.id) || []
    const areNetworksValid = newNetwork?.filter(n => !n?.value || n?.error) || []
    const changed = site?.name !== siteName?.value || site?.location !== location?.value || newNetwork?.length > 0

    if (
      !siteName.value ||
      siteName?.error ||
      !location?.value ||
      location?.error ||
      !timezone ||
      !changed ||
      areNetworksValid?.length > 0
    ) {
      return true
    } else {
      return false
    }
  }, [
    site,
    siteName,
    location,
    networks,
    timezone
  ]);

  return (
    <>
      <SDialog
        title={`${mode === 'add' ? 'Add' : 'Edit'} Sites`}
        open={showSitePopup}
        onClose={onClose}
        secondaryButtonConfig={{
          text: 'Cancel',
          onClick: onClose
        }}
        isFormDialog={true}
        width='40rem'
        primaryButtonConfig={{
          text: mode === 'add' ? 'Add' : 'Save',
          onClick: mode === 'add' ? handleCreateSite : handleUpdateSite,
          disabled: editDisabled
        }}
      >
        <FlexColumn alignItems='start'>
          <TextInput
            name="name"
            placeholder="Site Name"
            value={siteName.value}
            onChange={handleChange}
            error={siteName.error}
          />
          <FlexRow alignItems='start'>
            <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: '1 1 14rem' }}>
              <TextInput
                name="location"
                placeholder="Site Location"
                value={location.value}
                onChange={handleChange}
                error={location.error}
              />
            </FlexColumn>
            <FlexColumn gap='0.5rem' styles={{ flex: '1 1 14rem' }}>
              <Dropdown
                name="timezone"
                placeholder="Site Timezone"
                value={timezone}
                data={countryTimezones}
                onChange={(data) => setTimezone(data?.name)}
                disabled={mode !== 'add'}
              />
            </FlexColumn>
          </FlexRow>

          {mode !== 'add' && (
            <FlexRow justifyContent='space-between' flexWrap='nowrap'>
              <FlexColumn gap='0' alignItems='start'>
                <Typography variant={"b2M"} color='var(--brand-700)'>Networks</Typography>
                <Typography variant={"b3R"} color='var(--brand-500)'>Only {maxNetworks} networks are allowed per site.</Typography>
              </FlexColumn>
              {maxNetworks > 1 && networks.length !== maxNetworks && (
                <SButton
                  style={{ padding: '0.2rem 1rem' }}
                  variant={"primary"}
                  onClick={() => {
                    handleNetworkAddRemove('add');
                  }}
                >
                  <AddCircleIcon style={{ marginRight: '0.5rem', width: '1.3rem' }} /> Add
                </SButton>
              )}
            </FlexRow>
          )}

          {networks.map((network, index) => {
            let fieldType = 1; // without add/remove
            if (mode !== 'add' || (maxNetworks > 1 && index > 0)) {
              fieldType = 3; // with remove
            } else if (maxNetworks > 1 && networks.length !== maxNetworks && index === 0) {
              fieldType = 2; // with add
            }
            let field;
            switch (fieldType) {
              case 1:
                field = (
                  <TextInput
                    className={styles['multi-field-item-input']}
                    key={'network-' + index}
                    name="networks[]"
                    placeholder={'Network Name'}
                    value={network.value}
                    onChange={(e) => handleMultifieldChange(e, index)}
                    error={network.error}
                    disabled={network.id ? true : false}
                  />
                );
                break;
              case 2:
                field = (
                  <FlexRow flexWrap='nowrap' alignItems='start'>
                    <FlexColumn gap='0.5rem' alignItems='start'>
                      <TextInput
                        className={styles['multi-field-item-input']}
                        name="networks[]"
                        placeholder={'Network Name'}
                        value={network.value}
                        onChange={(e) => handleMultifieldChange(e, index)}
                        error={network.error}
                        disabled={network.id ? true : false}
                      />
                    </FlexColumn>

                    <SButton
                      style={{ marginTop: '1.5rem' }}
                      onClick={() => {
                        handleNetworkAddRemove('add', index);
                      }}
                    >
                      <AddCircleIcon style={{ marginRight: '0.5rem', width: '1.3rem' }} /> Add
                    </SButton>
                  </FlexRow>
                );
                break;
              default:
                field = (
                  <FlexRow flexWrap='nowrap' alignItems='start'>
                    <FlexColumn gap='0.5rem' alignItems='start'>
                      <TextInput
                        className={styles['multi-field-item-input']}
                        name="networks[]"
                        placeholder={'Network Name'}
                        value={network.value}
                        onChange={(e) => handleMultifieldChange(e, index)}
                        error={network.error}
                        disabled={network.id ? true : false}
                      />
                    </FlexColumn>
                    <SButton
                      style={{ marginTop: '1.5rem' }}
                      variant={"tertiary"}
                      onClick={() => {
                        handleNetworkAddRemove('remove', index);
                      }}
                    >
                      <SquareDelete style={{ height: '2.5rem', width: '2.5rem' }} />
                    </SButton>
                  </FlexRow>
                );
                break;
            }
            return field;
          })}

          {mode === 'add' && networks.length === maxNetworks && (
            <Typography variant={"b3R"} color='var(--info-500)'>Max networks allowed per site are {maxNetworks}. Contact support if more networks
              are needed.</Typography>
          )}
        </FlexColumn>
      </SDialog>

      <SDialog
        title='Delete Network'
        open={showDeleteNetworkPopup}
        onClose={() => {
          setShowDeleteNetworkPopup(false);
        }}
        secondaryButtonConfig={{
          text: 'Cancel',
          onClick: () => {
            setShowDeleteNetworkPopup(false);
          }
        }}
        primaryButtonConfig={{
          text: 'Delete',
          color: 'error',
          onClick: handleDeleteNetwork
        }}
      >
        <Typography variant={"b1M"} style={{ padding: '1.5rem 0' }}>Are you sure you want to delete this network, {currentNetworkId ? currentNetworkId.name : ''} ?</Typography>
      </SDialog>
    </>
  );
};

export default AddOrEditSiteModal;
